import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useGetAllProductsBySubcatIdQuery } from "../services/poductsApi";
import { CartContext } from "./CartContext";
import {
  useAddCartdetailsMutation,
  useLazyGetCardDetailsByUseridQuery,
} from "../services/cartApi";

import './SimilarProducts.css'

const SimilarProducts = ({ subcat_id, currentProductId }) => {
  const navigate = useNavigate();

  //  SAME CONTEXT USED IN ProductDetailsOne
  const { addToCart, setCart } = useContext(CartContext);

  //  SAME MUTATIONS USED IN ProductDetailsOne
  const [addCartfn] = useAddCartdetailsMutation();
  const [getAllCartDetailsfn] = useLazyGetCardDetailsByUseridQuery();

  const { data, isLoading } = useGetAllProductsBySubcatIdQuery(subcat_id);

  if (!subcat_id) return null;
  if (isLoading) return <p>Loading similar products...</p>;

  //  remove current product
  const filteredProducts = data?.data?.filter(
    (item) => String(item.product_id) !== String(currentProductId)
  );

  //  SAME add-to-cart LOGIC
  const handleAddToCart = (product) => {
    const customerId = localStorage.getItem("customer_id");

    const payload = {
      user_id: customerId,
      product_id: product.product_id,
      unit_id: product.unit_id,
      quantity: 1,
    };

    if (customerId) {
      addCartfn(payload)
        .then(() => getAllCartDetailsfn(customerId).unwrap())
        .then((response) => {
          if (response?.data) {
            setCart(response.data); //  UPDATE CONTEXT
          }
          navigate("/cart"); //  NAVIGATE AFTER STATE UPDATE
        })
        // .catch((err) => console.error("Add to cart error", err));
    } else {
      // Guest user
      addToCart({ ...product, quantity: 1 });
      navigate("/cart");
    }
  };

  return (
<div className="pt-80">
  <h4 className="mb-24">Similar Products</h4>

  <div className="similar-scroll">
    {filteredProducts.map((item) => (
      <div key={item.product_id} className="similar-card">

        {/* CARD TOP (DISCOUNT) */}
        {item.discount_percentage > 0 && (
          <div className="card-top">
            <span className="discount-badge">
              Upto {item.discount_percentage}% off
            </span>
          </div>
        )}

        {/* CARD BODY (IMAGE) */}
        <div className="card-body">
          <Link to={`/product-details/${item.product_id}/${item.unit_id}`}>
            <div className="img-zoom-wrapper">
              <img
                src={item.product_img_200}
                alt={item.product_name}
                className="similar-img"
              />
            </div>
          </Link>
        </div>

        {/* CARD FOOTER (DETAILS) */}
        <div className="card-footer">
          <h6 className="product-title" title={item.product_name}>
            {item.product_name}
          </h6>

          <div className="price-row">
            <span className="sale-price text-black">₹{item.sale_price}</span>
            <del className="mrp-price">₹{item.mrp}</del>
          </div>

          <button
            className="btn btn-main bg-success-400 w-100 rounded-pill"
            onClick={() => handleAddToCart(item)}
          >
            Add To Cart
          </button>
        </div>

      </div>
    ))}
  </div>
</div>


  );
};

export default SimilarProducts;
